import { Link } from "react-router-dom";
import React from "react";
import "../styles/AIWorkFilm.css";
import AI1 from "../assets/services/AI 1.jpeg";
import AI2 from "../assets/services/AI 2.jpeg";

const solutions = [
  {
    title: "AI Work Stations",
    description:
      "AI-powered work environments that help teams organize tasks, automate repetitive work and improve everyday productivity.",
  },
  {
    title: "AI Film Making",
    description:
      "Create visual stories, concepts and film content with modern AI-assisted creative workflows.",
  },
  {
    title: "AI Content Creation",
    description:
      "Develop written, visual and creative content faster with intelligent tools designed around your brand and audience.",
  },
  {
    title: "Creative Automation",
    description:
      "Automate repetitive creative processes while keeping your content consistent, useful and engaging.",
  },
  {
    title: "AI Workflow Design",
    description:
      "Design practical AI workflows that connect people, tools and processes to make work more efficient.",
  },
  {
    title: "AI Training & Support",
    description:
      "Learn how to use AI tools effectively through practical training, guidance and ongoing support.",
  },
];

const process = [
  {
    title: "Explore",
    description:
      "We understand your goals, workflow and creative requirements to identify where AI can create real value.",
  },
  {
    title: "Design",
    description:
      "We plan the right tools, workflow and creative direction around your specific requirements.",
  },
  {
    title: "Create",
    description:
      "We turn the planned workflow into useful content, automation or AI-assisted solutions.",
  },
  {
    title: "Refine",
    description:
      "We test, improve and optimize the workflow so it becomes practical for everyday use.",
  },
];

function AIWorkFilm() {
  return (
    <main className="ai-page">

      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="ai-hero">

        <div className="ai-hero-content">

          <span className="ai-eyebrow">
            AI WORK STATIONS & AI FILM MAKING
          </span>

          <h1>
            Create More With
            <span> Intelligent Workflows</span>
          </h1>

          <p>
            We combine artificial intelligence, creativity and smart
            workflows to help businesses and creators work faster,
            create better and explore new possibilities.
            Artificial Intelligence transforms how businesses operate, automating tasks and unlocking smarter decisions.
Our AI solutions are built to learn, adapt, and scale with your growth.
          </p>

          <a
            href="#ai-solutions"
            className="ai-primary-btn"
          >
            Explore AI Solutions
            <span>→</span>
          </a>

        </div>


        <div className="ai-hero-visual">

          <div className="ai-hero-image">

            <img
              src={AI1}
              alt="Artificial intelligence technology"
            />

          </div>

        </div>

      </section>


      {/* =====================================================
          WHAT WE DO
      ===================================================== */}

      <section className="ai-intro">

        <div className="ai-intro-header">

          <div className="ai-intro-label">

            <span>01</span>

            <p>
              WHAT WE CREATE
            </p>

          </div>


          <div className="ai-intro-heading">

            <h2>
              Intelligence that works
              <span> with your creativity</span>
            </h2>

            <p>
              From AI-powered workstations to film making and
              creative automation, we use modern AI tools to
              transform ideas into practical digital experiences.
            </p>

          </div>

        </div>


        <div className="ai-intro-content">

          <div className="ai-intro-main">

            <span>
              OUR APPROACH
            </span>

            <h3>
              AI should make work
              <strong> simpler, faster and more creative</strong>
            </h3>

            <p>
              We don't use AI simply because it is new. We focus on
              finding practical ways to use intelligent tools where
              they can save time, improve creativity and support
              better business outcomes.
            </p>

          </div>


          <div className="ai-intro-points">

            <div className="ai-intro-point">

              <span>01</span>

              <div>

                <h4>
                  Practical AI
                </h4>

                <p>
                  We focus on useful applications of AI that solve
                  real problems instead of adding unnecessary complexity.
                </p>

              </div>

            </div>


            <div className="ai-intro-point">

              <span>02</span>

              <div>

                <h4>
                  Creative freedom
                </h4>

                <p>
                  AI becomes a creative partner that helps teams
                  explore ideas and produce content more efficiently.
                </p>

              </div>

            </div>


            <div className="ai-intro-point">

              <span>03</span>

              <div>

                <h4>
                  Smarter workflows
                </h4>

                <p>
                  We connect tools and processes to create smoother
                  workflows that can evolve with your requirements.
                </p>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          AI SERVICES
      ===================================================== */}

      <section
        className="ai-solutions"
        id="ai-solutions"
      >

        <div className="ai-section-heading">

          <div>

            <span className="ai-small-label">
              AI SERVICES
            </span>

            <h2>
              Explore what
              <span> AI can create</span>
            </h2>

          </div>


          
           

        </div>


        <div className="ai-solutions-grid">

          {solutions.map((item) => (

            <article
              className="ai-solution-card"
              key={item.title}
            >

              <div className="ai-card-content">

                <h3>
                  {item.title}
                </h3>

                <p>
                  {item.description}
                </p>

              </div>

            </article>

          ))}

        </div>

      </section>


      {/* =====================================================
          AI WORKFLOW SECTION
      ===================================================== */}

      <section className="ai-tech-section">

        <div className="ai-tech-content">

          <span className="ai-small-label">
            INTELLIGENT CREATION
          </span>

          <h2>
            From imagination
            <span> to execution</span>
          </h2>

          <p>
            Modern AI gives creators and businesses new ways to
            experiment, produce and improve their work. We help
            turn these possibilities into structured workflows
            that people can actually use.
          </p>


          <div className="ai-tech-points">

            <div>

              <strong>01</strong>

              <h4>
                AI-assisted creation
              </h4>

              <p>
                Explore ideas, concepts and content with intelligent
                creative tools.
              </p>

            </div>


            <div>

              <strong>02</strong>

              <h4>
                Faster production
              </h4>

              <p>
                Reduce repetitive work and move from idea to output
                more efficiently.
              </p>

            </div>


            <div>

              <strong>03</strong>

              <h4>
                Connected workflows
              </h4>

              <p>
                Bring multiple AI tools and processes together
                into one practical workflow.
              </p>

            </div>

          </div>

        </div>


        <div className="ai-tech-visual">

          <div className="ai-tech-image">

            <img
              src={AI2}
              alt="AI creative technology"
            />

          </div>

        </div>

      </section>


      {/* =====================================================
          PROCESS
      ===================================================== */}

      <section className="ai-process">

        <div className="ai-process-heading">

          <span className="ai-small-label">
            HOW WE WORK
          </span>

          <h2>
            Idea to
            <span> intelligent output</span>
          </h2>

          <p>
            A structured process helps us turn AI possibilities
            into practical solutions without losing the human
            creativity behind them.
          </p>

        </div>


        <div className="ai-process-grid">

          {process.map((item, index) => (

            <article
              className="ai-process-item"
              key={item.title}
            >

              <div className="ai-process-number">
                {String(index + 1).padStart(2, "0")}
              </div>

              <h3>
                {item.title}
              </h3>

              <p>
                {item.description}
              </p>

            </article>

          ))}

        </div>

      </section>


      {/* =====================================================
          FINAL CTA
      ===================================================== */}

      <section className="ai-final">

        <div className="ai-final-content">

          <div className="ai-final-main">

            <div className="ai-final-label">

              <span></span>

              CREATE WITH INTELLIGENCE

            </div>


            <h2>
              Your next idea
              <span> could start with AI</span>
            </h2>


            <p>
              Tell us what you want to create, automate or
              improve. We can help you explore the right AI
              tools and turn your idea into something useful.
            </p>

          </div>


          <div className="ai-final-action">

            <div className="ai-final-brand">

              <strong>
                TECHLYNX INNOVATIONS
              </strong>

              <p>
                AI · Creativity · Technology
              </p>

            </div>


            <Link
              to="/contact"
              className="ai-final-btn"
            >
              Start a conversation
              <span>↗</span>
            </Link>

          </div>

        </div>

      </section>

    </main>
  );
}

export default AIWorkFilm;